import { render, staticRenderFns } from "./r-daily-bonus-tracks.vue?vue&type=template&id=38cc37a4"
import script from "./r-daily-bonus-tracks.vue?vue&type=script&lang=js"
export * from "./r-daily-bonus-tracks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cc37a4')) {
      api.createRecord('38cc37a4', component.options)
    } else {
      api.reload('38cc37a4', component.options)
    }
    module.hot.accept("./r-daily-bonus-tracks.vue?vue&type=template&id=38cc37a4", function () {
      api.rerender('38cc37a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/daily-bonus/r-daily-bonus-tracks.vue"
export default component.exports